<template>
	<div>
		<sui-modal v-model="open" size="small">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">Restablecer contraseña</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="close"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-form @submit.prevent>
						<sui-form-field>
							<h3>{{ descripcion }}</h3>
						</sui-form-field>
						<sui-form-field>
							<BaseInput
								v-model="contrasenia"
								titulo="Nueva contraseña"
								placeholder="Nueva contraseña"
								type="password"
								:error="erroresValidacion && !validationContra"
							></BaseInput>
						</sui-form-field>
						<sui-form-field>
							<BaseInput
								v-model="confirmarContrasenia"
								titulo="Confirmar contraseña"
								placeholder="Confirmar contraseña"
								type="password"
								:error="erroresValidacion && !validationConfirmaContra"
							></BaseInput>
						</sui-form-field>
						<base-button
							class="boldFont"
							style-button="primary"
							style-class="right floated"
							:loading="loading"
							@click.native="toggle"
							>Guardar</base-button
						>
					</sui-form>
				</sui-modal-description>
			</sui-modal-content>
		</sui-modal>
	</div>
</template>
<script>
import Notification from '../utils/notification';
export default {
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		descripcion: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			open: false,
			erroresValidacion: false,
			contrasenia: '',
			confirmarContrasenia: ''
		};
	},
	computed: {
		validationContra() {
			return this.contrasenia !== undefined && this.contrasenia.trim() !== '';
		},
		validationConfirmaContra() {
			return (
				this.confirmarContrasenia !== undefined &&
				this.confirmarContrasenia.trim() !== ''
			);
		},
		validationContraseñasIguales() {
			return (
				this.validationContra &&
				this.validationConfirmaContra &&
				this.contrasenia === this.confirmarContrasenia
			);
		}
	},
	watch: {
		open(val) {
			if (!val) {
				this.erroresValidacion = false;
				this.contrasenia = '';
				this.confirmarContrasenia = '';
				this.$emit('close', {});
			}
		}
	},
	mounted() {},
	methods: {
		toggle($event) {
			event.preventDefault();
			if (this.open) {
				if (this.validationContra && this.validationConfirmaContra) {
					if (!this.validationContraseñasIguales) {
						Notification('error', 'Las contraseñas no coinciden');
						return;
					}
					this.erroresValidacion = false;
					this.$emit('guardar', this.contrasenia);
				} else {
					this.erroresValidacion = true;
				}
			} else {
				this.open = !this.open;
			}
		},
		close() {
			this.open = false;
		},
		aceptar() {}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.danger {
	color: $background-danger;
}
</style>
